module.exports = __webpack_public_path__ + "img/nine-square.5b36c53c.png";